import API from "./api.js";
/**
 * Admin login
 * @param {string} username - Admin username
 * @param {string} password - Admin password
 * @returns {Promise<Object>} Response data
 */
export const adminLogin = async (username, password) => {
  const response = await API.post("/admin/login", {
    username,
    password,
  });
  return response.data;
};
//ggttff
//ggttff
//ggttff
// ggttff
//serwfgbvhb
/**
 * Send policy update notification to all users (Admin only)
 * @param {string} policyType - 'privacy' or 'terms'
 * @param {string} token - Admin auth token
 * @returns {Promise<Object>} Response data
 */
export const notifyPolicyUpdate = async (policyType, token) => {
  const response = await API.post(
    "/admin/notify-policy-update",
    { policyType },
    {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    }
  );
  return response.data;
};
//ggttff
/**
 * Get all MongoDB databases and collections (Admin only)
 * @param {string} token - Admin auth token
 * @returns {Promise<Object>} Response data with collections and counts
 */
export const getDatabases = async (token) => {
  const response = await API.get("/admin/databases", {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });
  return response.data;
};

export const getCollectionDocuments = async (
  collectionName,
  token,
  page = 1,
  limit = 20,
  options = {}
) => {
  const { search = "", sortBy = "", sortOrder = "desc" } = options;
  const params = { page, limit };
  if (search) params.search = search;
  if (sortBy) {
    params.sortBy = sortBy;
    params.sortOrder = sortOrder;
  }
  const response = await API.get(`/admin/databases/${encodeURIComponent(collectionName)}`, {
    params,
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });
  return response.data;
};

export const updateCollectionDocument = async (collectionName, documentId, data, token) => {
  const response = await API.put(
    `/admin/databases/${encodeURIComponent(collectionName)}/${encodeURIComponent(documentId)}`,
    data,
    {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    }
  );
  return response.data;
};

export const deleteCollectionDocument = async (collectionName, documentId, token) => {
  const response = await API.delete(
    `/admin/databases/${encodeURIComponent(collectionName)}/${encodeURIComponent(documentId)}`,
    {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    }
  );
  return response.data;
};
